import { render, staticRenderFns } from "./FileDownloadLink.vue?vue&type=template&id=538ca76f&scoped=true&"
import script from "./FileDownloadLink.vue?vue&type=script&lang=js&"
export * from "./FileDownloadLink.vue?vue&type=script&lang=js&"
import style0 from "./FileDownloadLink.vue?vue&type=style&index=0&id=538ca76f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538ca76f",
  null
  
)

export default component.exports